import { Radio } from 'antd'
import styled from 'styled-components'

const SyncOptions = styled(Radio.Group)`
	width: 100%;

	.ant-radio-wrapper {
		align-items: center;

		.ant-radio {
			top: 0;
		}
	}
`
export default { SyncOptions }
